import React from 'react'
import { Col, Card } from 'react-angle-dashboard-components'
import { UserInfo } from '../../../context/Auth'
import { InfoRow } from './InfoRow'

export const AccountInformation: React.FC<{ user: UserInfo | null }> = ({
  user
}) => {
  return (
    <Col style={{ marginTop: -115 }} className="px-3">
      <h5>Account Information</h5>
      <Card className="mt-4">
        <Card.Body>
          <InfoRow
            name="Full name"
            value={user?.first_name + ' ' + user?.last_name}
          />
          <InfoRow name="Email" value={user?.email || ''} bottomRow />
        </Card.Body>
      </Card>
    </Col>
  )
}
